import { withModalProvider } from "../../hoc/withModalProvider";

import { UserMembershipRemoveButton as View, IProps } from "./UserMembershipRemoveButton";

export const UserMembershipRemoveButton = withModalProvider<IProps>(View);
